import { validateConfig } from "../instruments.js";
/**
 * This method not only retrieve the list of instruments but also based on the user
 * request set some active experiments for all the instruments
 * @param preferences
 * @param request
 * @param instrumentsConfig
 * @returns
 */
export function getInstruments(request, instrumentsConfig) {
    const config = validateConfig(instrumentsConfig);
    if (!request) {
        return config;
    }
    const sampleIsPolymer = request.analysis?.data?.isPolymer;
    const requestedExperiments = request.analysis?.data?.experiments
        ? new Set(Object.entries(request.analysis.data.experiments)
            .filter(([, value]) => value === true)
            .map(([key]) => key))
        : new Set();
    for (const instrument of Object.values(config.instruments)) {
        for (const experiment of instrument.experiments) {
            const { requestKey } = experiment;
            experiment.enabled =
                requestKey !== undefined &&
                    requestedExperiments.has(requestKey) &&
                    (experiment.isPolymer === undefined ||
                        experiment.isPolymer === sampleIsPolymer);
        }
    }
    return config;
}
//# sourceMappingURL=getInstruments.js.map